/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps } from '@mui/material';

// eslint-disable-next-line complexity
export const headerSearchSX = ({
	isMobile,
	expanded,
}: {
	isMobile?: boolean;
	expanded?: boolean;
}): SxProps => ({
	transition:
		expanded && !isMobile
			? 'width 0.6s ease-in-out, max-width 0.6s ease-in-out, right 0.6s ease-in-out, top 0.6s ease-in-out'
			: 'none',
	width: isMobile ? '90%' : expanded ? '100%' : '180px',
	maxWidth: isMobile ? '90%' : expanded ? '100%' : '180px',
	marginRight: '0px',
	paddingBottom: expanded ? '11px' : 'inherit',
	paddingTop: expanded ? '12px' : 'inherit',
	position: expanded ? 'relative' : 'relative',
	right: expanded ? 0 : 'inherit',
	top: expanded ? 0 : 'inherit',
	marginLeft: isMobile ? '0px !important' : expanded ? '0px !important' : 'inherit',
	marginTop: isMobile ? '11px' : '0px',
	display: headerBreak({ mobile: 'flex', desktop: 'inherit' }),
	...(isMobile ? { mb: 2, ml: 0, mr: 2 } : {}),

	'.MuiOutlinedInput-notchedOutline': {
		borderColor: '#F1F1F1 !important',
		'&:hover': {
			borderColor: 'transparent !important',
		},
	},

	'.MuiInputBase-sizeSmall': {
		borderRadius: '20px',
		backgroundColor: '#F1F1F1',
		paddingLeft: '15px!important',
		height: isMobile ? '50px' : '38px',
	},

	'.MuiOutlinedInput-input': {
		'&::-webkit-input-placeholder': {
			opacity: 0.5,
		},
	},
});

export const headerSearchMobileButtonIconSX = () => ({
	color: '#2C2C2C',
	fontSize: '1.6rem',
});
